// @flow

import * as React from 'react';
import styled from 'styled-components';
import Overlay from 'ol/overlay';
import icon from './drone.svg';

const StyledMarker = styled.img`
  height: 35px;
  width: 100%;
  display: ${props => props.visible ? "initial": "none"};
`;

type DroneMarkerProps = {
  location: Array<number>,
  marker: Overlay
}

export class DroneMarker extends React.Component<DroneMarkerProps> {
  domNode: any;

  componentDidUpdate(): void {
    const { location, marker }: Props = this.props;
    //if (!location) return;
    marker.setPosition([location.x, location.y]);
  }

  componentDidMount(): void {
    const { marker }: Props = this.props;
    marker.setElement(this.domNode);
    marker.setPosition(undefined);
  }

  componentWillUnmount(): void {
    const { marker }: Props = this.props;
    marker.setPosition(undefined);
  }

  render(): React.Node {
    return (<StyledMarker src={icon} visible={this.props.visible} innerRef={(node) => { this.domNode = node }} />);
  }
};

export default DroneMarker;


// WEBPACK FOOTER //
// ./src/containers/content/map/videos/DroneMarker.jsx